enum OrderQueues {
    Dashboard = "Dashboard", 
    AllOrders = "AllOrders", 
    NewOrders = "NewOrders",
    NotPaidOrders = "NotPaidOrders",
    ERPSyncErrors = "DUESyncErrors", 
    SentToERP = "SentToERP",
    PartiallyShipped = "PartiallyShipped",
    Closed = "Closed",
    Cancelled = "Cancelled",
}

export default OrderQueues;